import { render, staticRenderFns } from "./APERevalidateResult.vue?vue&type=template&id=3f5bca7a&scoped=true"
import script from "./APERevalidateResult.vue?vue&type=script&lang=js"
export * from "./APERevalidateResult.vue?vue&type=script&lang=js"
import style0 from "./APERevalidateResult.vue?vue&type=style&index=0&id=3f5bca7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5bca7a",
  null
  
)

export default component.exports